module.exports = __webpack_public_path__ + "img/download-nt-prod.1a4036d3.png";